module.exports = __webpack_public_path__ + "2fce7a020e4b7ddaf39fdd04eeae683b.jpg";